import { render, staticRenderFns } from "./CreatorLead.vue?vue&type=template&id=b2ffa19e&scoped=true"
import script from "./CreatorLead.vue?vue&type=script&lang=js"
export * from "./CreatorLead.vue?vue&type=script&lang=js"
import style0 from "./CreatorLead.vue?vue&type=style&index=0&id=b2ffa19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ffa19e",
  null
  
)

export default component.exports